export default __webpack_public_path__ + "static/eviquire-logo-b651d8095629a14eac4fa11a9ce13b6b.png";